import { render } from "./YandexMap.vue?vue&type=template&id=8dd2684e&scoped=true"
import script from "./YandexMap.vue?vue&type=script&lang=js"
export * from "./YandexMap.vue?vue&type=script&lang=js"

import "./YandexMap.vue?vue&type=style&index=0&id=8dd2684e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd2684e"]])

export default __exports__